module.exports = __webpack_public_path__ + "static/media/24.ea0782c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/24.png
// module id = 806
// module chunks = 0